import Trans from '@/components/shared/Trans';
import translations from '@/components/EventTypeForm/EventTypeForm.trans.json';

export const CLASSIFICATIONS = ['positive', 'negative', 'neutral'];

export const isClassificationUnset = (classification) => classification == null;

export const QUALIFICATION = {
  negative: 0,
  positive: 1,
  neutral: 2,
};

export const CLASSIFICATION_ICONS = {
  positive: 'icon-positivo',
  negative: 'icon-negativo',
  neutral: 'icon-neutro',
};

export const CLASSIFICATION_TEXTS = {
  positive: Trans(translations, 'ClassificationPositive'),
  negative: Trans(translations, 'ClassificationNegative'),
  neutral: Trans(translations, 'ClassificationNeutral'),
};

export const getDefaultClosureName = (classification) =>
  CLASSIFICATION_TEXTS[classification] ?? CLASSIFICATION_TEXTS.neutral;
